import { get, chain, identity } from 'lodash';
import { addHttps } from './add-https';
export const getEmailBackgroundUrl = (composerData) => chain([
    get(composerData, 'background.data.image.url'),
    get(composerData, 'styles.settings.defaultBackground'),
])
    .filter(identity)
    .map((url) => (url === 'none' ? null : addHttps(url || '')))
    .union([null])
    .first()
    .value();
//# sourceMappingURL=get-email-background-url.js.map